import React from "react";
import { Tag } from "antd";
import { Drivability } from "@/typedefs/vehicle";
import { DrivabilityMap } from "@/utils/enum";
export default function DrivabilityTag({ drivabilityType, bold = false, onlyWhenInoperational = false, }) {
    if (onlyWhenInoperational && drivabilityType !== Drivability.Inoperational) {
        return null;
    }
    return (React.createElement(Tag, { color: drivabilityType === Drivability.Inoperational ? "error" : "success", style: { marginLeft: 5, fontWeight: bold ? "bold" : "normal" } }, DrivabilityMap[drivabilityType]));
}
DrivabilityTag.defaultProps = {
    bold: false,
    onlyWhenInoperational: false,
};
